import React, { useContext, useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { ProductContext } from '../context/ProductContext';

const Categories = () => {
  const { categories, filters, setFilters } = useContext(ProductContext);
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [showButtons, setShowButtons] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => setShowButtons(window.innerWidth > 576);
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const scrollBy = (amount) => {
    if (sliderRef.current) sliderRef.current.scrollLeft += amount;
  };

  const selectCategory = (category) => {
    setFilters({ category, search: '' });
    navigate('/');
  };

  if (!categories || categories.length === 0) {
    return (
      <div className="flex gap-3 overflow-hidden border-b border-gray-100 bg-gray-50 px-4 py-3">
        {[1, 2, 3, 4, 5].map((p) => (
          <div key={p} className="skeleton h-10 w-24 shrink-0 rounded-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 border-b border-gray-100 bg-gray-50 px-2 py-3 sm:px-4">
      {showButtons && (
        <button
          onClick={() => scrollBy(-200)}
          aria-label="Scroll left"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200"
        >
          <FiChevronLeft />
        </button>
      )}

      <div ref={sliderRef} className="flex flex-1 gap-2 overflow-x-auto scroll-smooth scrollbar-hide">
        <button
          onClick={() => selectCategory(null)}
          className={`shrink-0 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition ${
            !filters.category
              ? 'border-brand-600 bg-brand-600 text-white'
              : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100'
          }`}
        >
          All
        </button>
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => selectCategory(category)}
            className={`shrink-0 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium capitalize transition ${
              filters.category === category
                ? 'border-brand-600 bg-brand-600 text-white'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            {category.replace(/-/g, ' ')}
          </button>
        ))}
      </div>

      {showButtons && (
        <button
          onClick={() => scrollBy(200)}
          aria-label="Scroll right"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200"
        >
          <FiChevronRight />
        </button>
      )}
    </div>
  );
};

export default Categories;
